var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBgSound = function SvgBgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 99 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bg-sound_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 25,
    fill: "url(#bg-sound_svg__b)",
    rx: 12.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 14.169q0-.22-.068-.39a.76.76 0 0 0-.23-.313 1.9 1.9 0 0 0-.468-.274 6 6 0 0 0-.762-.278 9 9 0 0 1-.937-.347 3.6 3.6 0 0 1-.743-.449 1.9 1.9 0 0 1-.493-.59 1.65 1.65 0 0 1-.176-.777q0-.434.181-.791.186-.357.523-.615.341-.264.805-.406.464-.146 1.026-.146.79 0 1.362.293.576.293.884.786.312.494.312 1.089H14.6q0-.351-.151-.62a1.03 1.03 0 0 0-.45-.43q-.297-.156-.756-.156-.434 0-.723.132a.96.96 0 0 0-.43.356.93.93 0 0 0-.141.508q0 .2.093.366.093.161.283.303.19.136.479.259.288.122.678.234.592.176 1.03.39.44.21.733.48.293.268.44.61.146.337.146.766 0 .45-.18.81-.182.357-.518.611a2.5 2.5 0 0 1-.801.386q-.465.132-1.035.132a3.8 3.8 0 0 1-1.011-.137 3 3 0 0 1-.899-.415 2.15 2.15 0 0 1-.644-.703 2 2 0 0 1-.24-.991h1.226q0 .346.118.59.12.245.336.4.216.153.498.225.29.075.616.074.429 0 .717-.122a.95.95 0 0 0 .44-.342.9.9 0 0 0 .146-.508m8.134-1.919v.39q0 .807-.21 1.446-.21.64-.6 1.089-.387.45-.928.688a3 3 0 0 1-1.202.235q-.654 0-1.196-.235a2.7 2.7 0 0 1-.933-.688 3.2 3.2 0 0 1-.615-1.09 4.5 4.5 0 0 1-.215-1.444v-.391q0-.806.215-1.44.214-.64.606-1.09.395-.453.932-.688.542-.24 1.197-.239.66 0 1.2.24.543.233.933.688.39.45.6 1.089.216.634.216 1.44m-1.226.39v-.4q0-.595-.117-1.05a2.2 2.2 0 0 0-.337-.766 1.4 1.4 0 0 0-.542-.469 1.6 1.6 0 0 0-.727-.161q-.406 0-.723.161-.317.156-.542.469-.22.307-.337.766a4.2 4.2 0 0 0-.117 1.05v.4q0 .597.117 1.055.117.459.342.777.23.312.547.473.317.156.722.157.41 0 .728-.157.317-.16.537-.473.22-.317.332-.777.117-.459.117-1.054m6.59-3.75h1.221v4.752q0 .81-.351 1.357-.352.547-.957.825-.6.274-1.343.274-.767 0-1.367-.274-.6-.278-.947-.825-.342-.547-.342-1.357V8.89h1.22v4.75q0 .513.176.845a1.1 1.1 0 0 0 .498.484q.322.156.762.156t.757-.156a1.1 1.1 0 0 0 .498-.484q.176-.332.176-.844zm8.344 0V16h-1.226l-3.188-5.093V16h-1.226V8.89h1.226l3.198 5.103V8.891zM40.117 16H38.6l.01-.972h1.508q.66 0 1.104-.288.45-.288.674-.825.23-.537.23-1.28v-.385q0-.576-.133-1.02a2 2 0 0 0-.38-.748 1.6 1.6 0 0 0-.616-.459 2.1 2.1 0 0 0-.835-.156H38.57v-.976h1.592q.709 0 1.294.239.586.234 1.011.679.429.443.66 1.064.229.62.229 1.387v.376q0 .766-.23 1.387a3 3 0 0 1-.659 1.064q-.43.44-1.025.679a3.6 3.6 0 0 1-1.324.234m-.84-7.11V16h-1.225V8.89z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-sound_svg__b",
    x1: 50,
    x2: 49.5,
    y1: 0,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2A9276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363636",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-sound_svg__a",
    width: 99,
    height: 29,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_832_735"
  })))));
};
export default SvgBgSound;